import { render } from "./ManagerComponent.vue?vue&type=template&id=5fc430e4&scoped=true"
import script from "./ManagerComponent.vue?vue&type=script&lang=js"
export * from "./ManagerComponent.vue?vue&type=script&lang=js"

import "./ManagerComponent.vue?vue&type=style&index=0&id=5fc430e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc430e4"]])

export default __exports__